<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 112">
    <path
      d="M80,56A24,24,0,1,1,56,32,24,24,0,0,1,80,56Zm26,4H95.8A40,40,0,0,1,60,95.8V106H52V95.8A40,40,0,0,1,16.2,60H6V52H16.2A40,40,0,0,1,52,16.2V6h8V16.2A40,40,0,0,1,95.8,52H106ZM88,56A32,32,0,1,0,56,88,32,32,0,0,0,88,56Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconUserCenter'
}
</script>
